import React from 'react';
import ProjectPageInfo from '../components/ProjectPageInfo/ProjectPageInfo';

const desktopImages = [
  {
    id: 1, name: 'Homepage', url: '/images/desktop/avondale/avondale-INDEX.jpg',
  },
  {
    id: 2, name: 'Getting Started', url: '/images/desktop/avondale/avondale-GETTING-STARTED.jpg',
  },
  {
    id: 3, name: 'Members', url: '/images/desktop/avondale/avondale-MEMBERS.jpg',
  },
  {
    id: 4, name: 'How It Works', url: '/images/desktop/avondale/avondale-HOW-IT-WORKS.jpg',
  },
  {
    id: 5, name: 'Plus', url: '/images/desktop/avondale/avondale-PLUS.jpg',
  },
  {
    id: 6, name: 'Premium', url: '/images/desktop/avondale/avondale-PREMIUM.jpg',
  },
  {
    id: 7, name: 'Prime', url: '/images/desktop/avondale/avondale-PRIME.jpg',
  },
];

const mobileImages = [
  {
    id: 1, name: 'Homepage', url: '/images/mobile/avondale/avondale-INDEX-mobile.jpg',
  },
  {
    id: 2, name: 'Getting Started', url: '/images/mobile/avondale/avondale-GETTING-STARTED-mobile.jpg',
  },
  {
    id: 3, name: 'Members', url: '/images/mobile/avondale/avondale-MEMBERS-STORIES-mobile.jpg',
  },
  {
    id: 4, name: 'How It Works', url: '/images/mobile/avondale/avondale-HOW-IT-WORKS-mobile.jpg',
  },
  {
    id: 5, name: 'Plus', url: '/images/mobile/avondale/avondale-PLUS-mobile.jpg',
  },
  {
    id: 6, name: 'Premium', url: '/images/mobile/avondale/avondale-PREMIUM-mobile.jpg',
  },
  {
    id: 7, name: 'Prime', url: '/images/mobile/avondale/avondale-PRIME-mobile.jpg',
  },
];

const Avondale = () => (
  <>
      <ProjectPageInfo
        title="Avondale Select"
        icon="bi bi-geo-fill"
        location="Dallas, TX"
        liveUrl="https://www.avondale.com/"
        desktopImages={desktopImages}
        mobileImages={mobileImages}
        backgroundColor="#a10620"
        backgroundColorTwo="#c80f2e"
        heroImage="/images/project-page/avondale/avondale-hero.png"
        imacIpad="/images/project-page/avondale/avondale-imac-ipad.png"
        phoneOne="/images/project-page/avondale/avondale-phone.png"
        phoneTwo="/images/project-page/avondale/avondale-iphone-2.png"
      />
  </>
);

export default Avondale;
